import { render, staticRenderFns } from "./FirestoreImport.vue?vue&type=template&id=72b4ae66&"
import script from "./FirestoreImport.vue?vue&type=script&lang=js&"
export * from "./FirestoreImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports